import EfFaq from '@elem/ui/ef-faq';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.FaqA');
    const listA = [
        {
            title: t('faq_title1'),
            desc: t('faq_desc1'),
        },
        {
            title: t('faq_title2'),
            desc: t('faq_desc2'),
        },
        {
            title: t('faq_title3'),
            desc: t('faq_desc3'),
        },
        {
            title: t('faq_title4'),
            desc: t('faq_desc4'),
        },
    ];
    return (
        <div className={styles.TheComp} id={PageNavType.FAQ}>
            <EfSpec />
            <EfTitle className="faq-title">{t('title')}</EfTitle>
            <EfFaq items={listA} />
            <EfSpec />
        </div>
    );
}
